import { colors } from '../../styles/theme';

const iconColors = {
  asterisk: {
    normal: colors.orange.primary,
  },
  checkmark: {
    normal: colors.green,
  },
  lock: {
    normal: colors.blue.primary,
  },
  'c-logo': {
    normal: colors.blue.primary,
  },
  spinner: {
    normal: colors.grey.primaryLight,
  },
  unlock: {
    normal: colors.grey.secondaryDark,
  },
  warning: {
    normal: colors.yellowDark,
  },
  x: {
    normal: colors.grey.altDark,
    hover: colors.red.primary,
  },
  close: {
    normal: colors.grey.altDark,
    hover: colors.black,
  },
};

export default iconColors;
